<template>
  <div class="container">
    <div @click="$emit('close')" class="close">❌</div>
    <div class="title">
      <div class="center">
        <img src="@/assets/Escape/logo.png" alt="" />
      </div>
      <div class="center">
        <h1 style="color: rgb(230, 230, 230); margin-bottom: none;">
          Le club des Escape Games Parisiens
        </h1>
      </div>
    </div>
    <div v-if="!victory">
      <div class="center">
        <input
          type="text"
          v-model="answer"
          v-on:keyup.enter="validate"
          placeholder="Mot de passe"
        />
      </div>
      <div class="center">
        <p class="error">{{ message }}</p>
      </div>
      <div class="center button-wrapper">
        <p @click="validate">Se connecter</p>
      </div>
    </div>
    <div v-if="victory">
      <div class="center">
        <h2>
          Félicitations, vous êtes arrivé au bout de notre série d'énigmes !
        </h2>
      </div>
      <div class="center">
        <p style="margin: 30px">
          Si vous arrivez sur cette page pour la première fois, c'est que vous
          rejoignez officiellement le Club des Escape-Games Parisiens en tant
          que nouveau membre. Vous avez réussi l'épreuve d'entrée, à nous
          maintenant de vous aider dans la réussite de votre projet. Nous allons
          sous peu étudier votre dossier !
        </p>
      </div>
    </div>
    <div class="final-footer">
      <p>
        Aides au financement - Recherche de local - Communication - Formation au
        "game-mastering"- Création d'énigmes - Réalisation de mécanismes
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Intro",
  components: {},
  props: ["startTime", "user", "hints"],
  data() {
    return {
      answer: null,
      message: null,
      password: "JUPITER",
      victory: false,
    };
  },
  methods: {
    validate() {
      this.message = null;
      this.answer.toUpperCase() === this.password.toUpperCase()
        ? (this.victory = true)
        : (this.message = "Mauvaise réponse !");
      if (this.victory) {
        const diff = Math.abs(new Date() - this.startTime);
        console.log("duration", Math.floor(diff / 1000 / 60));
        this.$http
          .post("https://mystery-engine.herokuapp.com/api/new", {
            game_log: {
              name: this.user,
              duration: Math.floor(diff / 1000 / 60),
              enigme: "escape",
              status: "finish",
              hint: this.hints,
            },
          })
          .then(
            function(response) {
              // Success
              console.log("session finished", response.data);
            },
            function(response) {
              // Error
              console.log(response.data);
            }
          );
      }
    },
  },
};
</script>

<style scoped>
p {
  font-family: "VT323", monospace;
  color: rgb(230, 230, 230);
}
h2 {
  font-family: "VT323", monospace;
  color: rgb(230, 230, 230);
}
.container {
  background: rgb(20, 20, 20);
  border: 10px solid rgb(120, 120, 120);
  overflow: scroll;
  position: relative;
}
.button-wrapper p {
  font-family: "VT323", monospace;
  background: #0383d0;
  text-align: center;
  color: white;
  padding: 10px 40px;
  border-radius: 10px;
}
.button-wrapper:hover p {
  opacity: 0.85;
  cursor: pointer;
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.final-footer {
  position: absolute;
  bottom: 25px;
  right: 5%;
  left: 5%;
  text-align: center;
}
.close:hover {
  cursor: pointer;
}
.center {
  text-align: center;
}
.title {
  margin: 10%;
}
input {
  font-size: 40px;
  max-width: 280px;
  letter-spacing: 4px;
  font-family: "VT323", monospace;
  font-weight: bold;
  text-align: center;
  background: rgb(250, 250, 250);
  line-height: 15px;
  color: rgb(80, 80, 80);
  border: none;
  text-transform: uppercase;
  border-bottom: 4px solid rgb(80, 80, 80);
}
input:focus {
  outline: none;
}
.error {
  color: #fd4212;
  font-weight: bold;
}
</style>
